import React, {useState} from 'react'
import {
  Box,
  Divider,
  Heading,
  Stack, Text,
} from "@chakra-ui/react";
import { MDXProvider } from "@mdx-js/react"
import {CodeSlot, Hike, Focus, PreviewSlot, withFocusHandler} from "@code-hike/scrollycoding";
import CustomLink from "./CustomLink";
import {MdxFrontmatter} from "../../gql/types";
import ReadingTime from "../page/ReadingTime";
import CodeBlock from "./CodeBlock";
import CodeHike from "./CodeHike";
import { format } from 'date-fns';
import Title from "../ui/atoms/Title";
import {calcReadingTime} from "../../utils/calcReadingTime";
import FontSizeSlider from "../ui/molecules/FontSizeSlider";

const shortcodes = {
  a: withFocusHandler(CustomLink),
  Hike,
  Focus,
  CodeSlot,
  PreviewSlot,
  CodeBlock,
  CodeHike,
}

export interface LayoutProps {
  pageContext: {
    body: string
    frontmatter: Omit<MdxFrontmatter, '__typename'>
  }
}

const defaultFontSize = 3;

const getFontSizeString = (fontSize: number) => ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', '8xl', '9xl'][fontSize] ?? 'md'

const MdxLayout: React.FC<LayoutProps> = ({children, ...props}) => {
  const {title, date} = props.pageContext.frontmatter;
  const [fontSize, setFontSize] = useState(defaultFontSize);

  return (
    <MDXProvider components={shortcodes}>
      <Box px={64} mb={'40vh'}>
        <Stack textAlign={'center'} spacing={{base: 8, md: 14}} pt={{base: 20, md: 36}} pb={{base: 12, md: 26}}>
          <Title/>
          <Heading fontWeight={500} fontSize={'3xl'} letterSpacing={4}>
            {title}
          </Heading>
          <Divider borderColor={'green.400'} mt={12} borderBottomWidth={1}/>
        </Stack>

        <Box mb={8}>
          <Text>{format(new Date(date), 'MMM dd, yyyy')} · <ReadingTime readingTime={calcReadingTime('')}/></Text>
        </Box>

        <FontSizeSlider defaultValue={defaultFontSize} onChange={setFontSize}/>

        <Box fontSize={getFontSizeString(fontSize)}>
          {children}
        </Box>
      </Box>
    </MDXProvider>
  )
}

export default MdxLayout
